/* eslint-disable camelcase */
import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Input } from 'antd';

const { TextArea } = Input;

const SingleReview = ({ cellValue, onFocusOut }) => {
  const [review, setReview] = useState(cellValue);
  const onChangeInput = (name) => (e) => {
    const { value } = e.target;
    setReview((prev) => ({ ...prev, [name]: value }));
  };
  return (
    <div>
      <div>
        <div> Name: </div>
        <Input
          placeholder="type here"
          name="name"
          type="text"
          onChange={onChangeInput('name')}
          onBlur={onFocusOut}
          value={review.name}
        />
      </div>
      <br />
      <div>
        <div> Rating: </div>
        <Input
          placeholder="type here"
          name="rating"
          type="number"
          onChange={onChangeInput('rating')}
          onBlur={onFocusOut}
          value={review.rating}
        />
      </div>
      <br />
      <div>
        <div> Comment: </div>
        <TextArea
          placeholder="type here"
          name="comment"
          type="text"
          onChange={onChangeInput('comment')}
          onBlur={onFocusOut}
          value={review.comment}
        />
      </div>
    </div>
  );
};

const MultipleReviews = ({ cellValue }) =>
  cellValue.map(({ time, rating, relative_time_description, text }) => (
    <div key={time} style={{ borderBottom: 'solid 1px gray', marginBottom: '12px', whiteSpace: 'normal' }}>
      <p> Rating: {rating} </p>
      <p> Message: {text} </p>
      <p> Review date: {relative_time_description} </p>
    </div>
  ));

export default function Review({ cellValue, onFocusOut }) {
  const isArray = Array.isArray(cellValue);

  return isArray ? (
    <MultipleReviews cellValue={cellValue} />
  ) : (
    <SingleReview cellValue={cellValue} onFocusOut={onFocusOut} />
  );
}

Review.propTypes = {
  cellValue: PropTypes.object,
  onFocusOut: PropTypes.func,
};

Review.defaultProps = {
  cellValue: {},
  onFocusOut: () => {},
};
